/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useContext } from "react";

import { DataContext as GasCheckoutDataContext } from "../../../../../providers/GasCheckoutDataProvider";
import gasPaymentTypes from "../../../../../providers/GasPaymentTypes";
import { navigate } from "../../../../shared/LinkComponent";
import Margin from "../../../../shared/Margin";
import NewHeadline from "../../../../shared/NewHeadline";
import OrderChangableDetail from "../../../../shared/OrderChangableDetail";
import ContactData from "../StepDeliveryAddress/ContactData";
import DeliveryAddress from "../StepDeliveryAddress/DeliveryAddress";
import StepDeliveryDetails from "../StepDeliveryDetails";
import StepPaymentType from "../StepPaymentType";
import Agb from "./Agb";
import Amount from "./Amount";
import GasCalculatorResult from "./GasCalculatorResult";
import ReceiveNewsletter from "./ReceiveNewsletter";
import * as styles from "./style.module.scss";

const StepOverview = () => {
    const gasCheckoutDataContext = useContext(GasCheckoutDataContext);

    const {
        chosenTarifName,
        consumption,
        deliveryDetails,
        deliveryAddressData,
        paymentData,
        place,
        street,
        houseNum,
        zipcode,
    } = gasCheckoutDataContext.data;

    const { setEditMode, setOverlayContent } = gasCheckoutDataContext.actions;
    const prices = gasCheckoutDataContext.actions.getPrices();

    return (
        <Margin Component="section" top="10">
            <NewHeadline>Bestelldetails</NewHeadline>
            <OrderChangableDetail
                label={`${chosenTarifName}`}
                changeContent={<GasCalculatorResult />}
                onOverlayInit={() => {
                    setOverlayContent("produkt");
                }}
                gtag="gas:checkout:overview:product"
                DataContext={GasCheckoutDataContext}
            />
            <OrderChangableDetail
                label={`Bedarf ${consumption} kWh`}
                changeContent={<Amount />}
                onOverlayInit={() => {
                    setOverlayContent("consumption");
                }}
                gtag="gas:checkout:overview:consumption"
                DataContext={GasCheckoutDataContext}
            />

            <OrderChangableDetail
                label={
                    gasPaymentTypes[paymentData.payment_payment_type - 1].name
                }
                changeContent={<StepPaymentType />}
                onOverlayInit={() => {
                    setOverlayContent("zahlart");
                }}
                gtag="gas:checkout:overview:payment-type"
                DataContext={GasCheckoutDataContext}
            />

            <OrderChangableDetail
                label="Kontaktdaten"
                value={
                    <div>
                        {deliveryAddressData.salutation}{" "}
                        {deliveryAddressData.firstname}{" "}
                        {deliveryAddressData.lastname}
                        {deliveryAddressData.email && (
                            <React.Fragment>
                                <br /> {deliveryAddressData.email}
                            </React.Fragment>
                        )}
                        {deliveryAddressData.phone && (
                            <React.Fragment>
                                <br /> {deliveryAddressData.phone}
                            </React.Fragment>
                        )}
                    </div>
                }
                changeContent={<ContactData />}
                onOverlayInit={() => {
                    setOverlayContent("lieferadresse");
                }}
                gtag="gas:checkout:overview:contact"
                DataContext={GasCheckoutDataContext}
            />

            <OrderChangableDetail
                label="Lieferadresse"
                value={
                    <div>
                        {String(street.value) + " " + String(houseNum)}
                        <br />
                        {zipcode} {place.value}
                    </div>
                }
                readOnly={true}
                onClick={() => {}}
                changeContent={<DeliveryAddress />}
                onOverlayInit={() => {}}
                DataContext={GasCheckoutDataContext}
            />

            <OrderChangableDetail
                label="Lieferdetails"
                value={
                    <div>
                        {deliveryDetails.delivery_movement_type}
                        <br />
                        {deliveryDetails.delivery_counter_number}
                    </div>
                }
                onClick={() => {
                    setEditMode(true);
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    navigate("/gas/bestellung/lieferdetails");
                }}
                changeContent={<StepDeliveryDetails />}
                onOverlayInit={() => {
                    setOverlayContent("lieferdetails");
                }}
                gtag="gas:checkout:overview:delivery-details"
                DataContext={GasCheckoutDataContext}
            />

            <Agb />
            <ReceiveNewsletter />
            <div className={styles.totalPrice}>
                Gesamtpreis: {prices.priceTotalGross}&nbsp;€
            </div>
        </Margin>
    );
};

export default StepOverview;
